import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule, DatePipe} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {EncryptionService, InitializerService} from '@atumverse/core-services';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {WebAppLayoutComponent} from './web/web-app-layout/web-app-layout.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {initFInfra} from './common/functions/init-app.function';
import {InjectService} from './common/services/inject.service';
import {TranslateModule} from '@atumverse/core-decorators';
import {FinfraPortalModule} from '@atumverse/portal-app';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FinfraDashboardContainerModule} from './portal/dashboard/finfra-dashboard-container/finfra-dashboard-container.module';
import {FunctionModule} from './portal/function/function.module';
import {FinfraAppCoreComponentsModule, FinfraFooterModule} from '@atumverse/app-core-components';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import { AtumverseWidgetsModule } from '@atumverse/common-widgets';
import {AtumverseIceModule} from '@atumverse/ice-app';
import { AtumverseCollectionsModule } from '@atumverse/collections-app';


import 'codemirror/lib/codemirror';

import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/css/css';

import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/xml-fold';

import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/matchtags';
import 'codemirror/addon/edit/closetag';

import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/json-lint';
import 'codemirror/addon/lint/javascript-lint';

@NgModule({
  declarations: [
    AppComponent,
    WebAppLayoutComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,

    TranslateModule,
    FinfraAppCoreComponentsModule,
    FinfraPortalModule,
    FinfraDashboardContainerModule,
    MatTooltipModule,
    AtumverseIceModule,
    AtumverseWidgetsModule,
    AtumverseCollectionsModule,

    FunctionModule,
    FinfraFooterModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    HttpClient,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initFInfra,
      deps: [InitializerService, InjectService, EncryptionService, HttpClient],
      multi: true,
    },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
